import { useMemo } from 'react'
import { BuyDownloadButtonCSV, BuyDownloadButtonPDF, BuyDownloadPdfTemplateButton, BuyDownloadTags, BuyPdfPreview, BuySupplierPdfPreview } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderBuyLayout/BuyButtons'
import { OrderStepButtonsDefaultBaseComponent, OrderStepButtonsNewStyleBaseComponent } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent'
import { OrderStepButtonsBase, OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { BuyInvoiceDuplicateButton } from '../../../BuyInvoiceButtons'
import { OrderDivideIntoChaptersButton } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtons'

const BuyInvoiceCreateNoPermissionButtons: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    return (
        <OrderStepButtonsDefaultBaseComponent {...{ data, onSubmit, hookFunction: useBuyInvoiceCreateNoPermissionButtonsLogic, ...rest }} className='mr-8' />
    )
}

const useBuyInvoiceCreateNoPermissionButtonsLogic = ({ data, onSubmit, isReadOnly }: OrderStepButtonsBaseComponentProps) => {
    const { t } = useTwinTranslation()
    const name = 'buy_invoice_create_no_permission_step_buttons'
    const Order = data?.header
    const showButtonByPricesPermission = !data?.header?.hidePrices

    const defaultButtons = [{ "id": "previewBuyInvoicePDF" }, { "id": "downloadBuyInvoice" }, { "id": "duplicateBuyInvoice" }]

    const buyInvoiceDuplicateText = t('duplicateBuyInvoice', 'Duplicar factura de compra')
    const buyInvoiceDownloadCSVText = t('downloadCsv', 'Descargar csv')
    const buyInvoiceDownloadTagsText = t('printTags', 'Imprimir etiquetas')
    const buyInvoicePreviewPDFText = t('previewPdfTemplate', 'Previsualizar plantilla PDF')
    const buyInvoiceDownloadPDFTemplateText = t('downloadPdfTemplate', 'Descargar plantilla PDF')
    const buyInvoiceDownloadPDFText = t('downloadPdf', 'Descargar PDF')
    const buyInvoiceDivideIntoChaptersText = t('divideIntoChapters', 'Dividir en capítulos')
    const buyOrderPreviewSupplierPDFText = t('previewSupplierPDF', 'Previsualizar PDF proveedor')

    const ButtonComponents: OrderStepButtonsBase = useMemo(() => {
        return {
            duplicateBuyInvoice: {
                component: BuyInvoiceDuplicateButton,
                showButton: showButtonByPricesPermission,
                extraProps: {
                    title: buyInvoiceDuplicateText,
                    id: 'duplicateBuyInvoice',
                    allRowData: data,
                    permissionTy: 'buy.invoice',
                }
            },
            downloadBuyCsv: {
                component: BuyDownloadButtonCSV,
                showButton: showButtonByPricesPermission,
                extraProps: {
                    title: buyInvoiceDownloadCSVText,
                    id: 'downloadBuyCsv',
                    Order,
                    typeTemplate: 'buyInvoice'
                }
            },
            downloadBuyTag: {
                component: BuyDownloadTags,
                showButton: showButtonByPricesPermission,
                extraProps: {
                    title: buyInvoiceDownloadTagsText,
                    id: 'downloadBuyTag',
                    Order,
                    typeTemplate: 'buyInvoice'
                }
            },
            previewBuySupplierPDF: {
                component: BuySupplierPdfPreview,
                showButton: Order.supplierPdf?.length,
                extraProps: {
                    title: buyOrderPreviewSupplierPDFText,
                    id: 'previewBuyOrderPDFSupplier',
                    Order,
                    typeTemplate: 'buyOrder',
                    key: 'previewBuyOrderPDFSupplier'
                }
            },
            previewBuyInvoicePDF: {
                component: BuyPdfPreview,
                showButton: showButtonByPricesPermission,
                extraProps: {
                    title: buyInvoicePreviewPDFText,
                    id: 'previewBuyInvoicePDF',
                    Order,
                    typeTemplate: 'buyInvoice',
                    key: 'downloadPreviewPDFTemplate'
                }
            },
            downloadBuyTemplate: {
                component: BuyDownloadPdfTemplateButton,
                showButton: showButtonByPricesPermission,
                extraProps: {
                    title: buyInvoiceDownloadPDFTemplateText,
                    id: 'downloadBuyTemplate',
                    Order,
                    typeTemplate: 'buyInvoice',
                    key: 'downloadBuyInvoicePDFTemplate'
                }
            },
            downloadBuyInvoice: {
                component: BuyDownloadButtonPDF,
                showButton: showButtonByPricesPermission,
                extraProps: {
                    title: buyInvoiceDownloadPDFText,
                    id: 'downloadBuyInvoice',
                    Order,
                    typeTemplate: 'buyInvoice',
                }
            },
            divideIntoChaptersQuote: {
                component: OrderDivideIntoChaptersButton,
                extraProps: {
                    title: buyInvoiceDivideIntoChaptersText,
                    id: 'divideIntoChaptersQuote',
                    allRowData: data,
                    onSubmit,
                    isReadOnly
                }
            },
        }
    }, [Order, buyInvoiceDivideIntoChaptersText, buyInvoiceDownloadCSVText, buyInvoiceDownloadPDFTemplateText, buyInvoiceDownloadPDFText, buyInvoiceDownloadTagsText, buyInvoiceDuplicateText, buyInvoicePreviewPDFText, data, isReadOnly, onSubmit, showButtonByPricesPermission, buyOrderPreviewSupplierPDFText])

    return { name, ButtonComponents, defaultButtons }
}

export const BuyInvoiceCreateNoPermissionButtonsNew: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    return (
        <OrderStepButtonsNewStyleBaseComponent {...{ data, onSubmit, hookFunction: useBuyInvoiceCreateNoPermissionButtonsLogic, ...rest }} className='mr-8' />
    )
}

export default BuyInvoiceCreateNoPermissionButtons